{
  "loadError": "Couldn't load the dashboard. Please try again.",
  "offlineError": "Can't reach the game server. Check your connection, then try again.",
  "retry": "Try again",
  "firstRace": {
    "eyebrow": "Your first race",
    "titleUpcoming": "{race} starts {when}",
    "titleSoon": "{race} is coming up",
    "titleStarted": "{race} is under way",
    "titlePause": "No race to pick right now",
    "when": {
      "today": "today at {time}",
      "tomorrow": "tomorrow at {time}",
      "date": "on {day} at {time}"
    },
    "at": {
      "today": "Today {time}",
      "tomorrow": "Tomorrow {time}",
      "date": "{day} {time}"
    },
    "stages": "{count, plural, one {# stage} other {# stages}}",
    "oneDay": "One-day race",
    "division": "your riders race in Division {division}",
    "now": "Now",
    "nowAssistant": "Pick your riders and captain. If you skip it, your assistant picks for you.",
    "nowPick": "Pick your riders and captain.",
    "nowSaved": "Your line-up is saved. You can change it until the race starts.",
    "stageRaced": "Stage {number} is raced.",
    "oneDayRaced": "The race is on.",
    "resultHere": "Your result is here.",
    "resultMail": "Your result is here, and it is emailed to you.",
    "takesAbout": "Takes about 2 minutes",
    "nextLabel": "Next",
    "pauseSeason": "The next season starts on {day}. Your first race will show up here.",
    "pauseUnknown": "Your first race will show up here as soon as it is on the calendar.",
    "openCalendar": "Open the race calendar",
    "viewRace": "View the race"
  },
  "todayStages": {
    "title": "Today's stages",
    "winner": "Winner: {name}",
    "standing": "#{rank} of {total} overall",
    "standingPending": "Overall position not settled yet",
    "entries": "{count, plural, one {# rider entered} other {# riders entered}}"
  },
  "header": {
    "subtitle": "Division {division} · {count, plural, one {1 rider} other {# riders}}",
    "incoming": "+{count} in",
    "outgoing": "−{count} out",
    "lockedInBids": "{value} CZ$ locked in bids"
  },
  "nextActions": {
    "title": "Next move",
    "loading": "Checking what needs you…",
    "allClear": "You're all caught up. Nothing needs your action right now.",
    "transferOffers": "{count, plural, one {1 transfer offer needs your decision} other {# transfer offers need your decision}}",
    "swapOffers": "{count, plural, one {1 swap proposal needs your decision} other {# swap proposals need your decision}}",
    "urgentAuctions": "{count, plural, one {1 auction ends within the hour} other {# auctions end within the hour}}",
    "squadSelectionMissing": "Squad selection missing for {race}",
    "notTrainedToday": "You have not trained today",
    "boardPlanMissing": "No board plan negotiated yet",
    "nextValueUpdate": "Next value update: {when}",
    "nextAcademyIntake": "Next academy intake: {when}"
  },
  "seasonStart": {
    "title": "Season {number}: get started",
    "dismissAria": "Dismiss the season start guide",
    "done": "Done",
    "progress": "{done} of {total} decisions made",
    "items": {
      "squad": {
        "title": "Build your squad",
        "desc": "Most teams start a season short of riders. Bid in the live auctions to fill the gaps."
      },
      "training": {
        "title": "Set the training plan",
        "desc": "Training plans belong to one season, so last season's plan no longer applies."
      },
      "board": {
        "title": "Sign your mandate",
        "desc": "The annual meeting is open. Answer each target and sign, or the board signs for you when the deadline runs out."
      },
      "boardLegacy": {
        "title": "Negotiate with the board",
        "desc": "Your new plan is waiting. Until you agree it, the season's targets are not settled."
      },
      "academy": {
        "title": "Decide on academy graduates",
        "desc": "Promote, sell or release riders who turned 21. After 7 days the engine promotes them if you have room and cash, otherwise it sells."
      }
    }
  },
  "seasonWrap": {
    "title": "Season {number} wrapped",
    "dismissAria": "Dismiss the season wrap card",
    "movement": {
      "promoted": "Promoted",
      "relegated": "Relegated",
      "maintained": "Held Division {division}"
    },
    "rankLine": "You finished #{rank} of {size} in Division {division}",
    "boardConfidence": "Board confidence {percent}%",
    "statsLine": "{points} points · {wins, plural, one {# win} other {# wins}}",
    "cta": "View your season recap",
    "goal": {
      "promoted": "Season {nextNumber} starts in a new division. First goal: stay clear of the relegation zone.",
      "relegated": "Season {nextNumber} starts now. Finish in the top two to bounce straight back up.",
      "heldTop": "Season {nextNumber} starts now. Defend your position at the top of Division {division}.",
      "heldBottom": "Season {nextNumber} starts now. No relegation risk down here, so climb the standings.",
      "heldMid": "Season {nextNumber} starts now. Push for a top-two finish and promotion."
    }
  },
  "seasonSignup": {
    "titleParked": "Your team was parked",
    "titleDormant": "Keep your spot for season {number}",
    "bodyParkedComeback": "No login for a while moved your team out of the league. Come back now and you race again this season, placed by your Global Rank.",
    "bodyDormant": "You have been away for a while. Sign up now to lock in your spot for season {number}.",
    "cta": "Sign up for next season",
    "ctaComeback": "Return to the league",
    "confirmed": "You are signed up for season {number}",
    "comebackTitle": "Welcome back",
    "comebackConfirmed": "Your team is back in Division {division} and races again this season.",
    "comebackError": "Could not bring your team back. Try again.",
    "error": "Could not sign up. Try again."
  },
  "squadWarning": {
    "over": "Squad too large. Max {limit} in Division {division}. Sell {count, plural, one {1 rider} other {# riders}}.",
    "under": "Squad too small. Min {limit} in Division {division}. Buy {count, plural, one {1 more rider} other {# more riders}}.",
    "ctaMyTeam": "My Team"
  },
  "seniorStartWarning": {
    "message": "Senior squad: {count} of {min}. You need {missing, plural, one {1 more rider} other {# more riders}} to start a race.",
    "cta": "Find a rider"
  },
  "contractWarning": {
    "message": "{count, plural, one {1 rider's contract expires} other {# riders' contracts expire}} at the season change. Renew from the rider's profile to keep them, or they'll be released as free agents.",
    "cta": "Review contracts",
    "letExpire": "I understand, let it expire",
    "dismissAria": "Dismiss for this season"
  },
  "discordNudge": {
    "title": "Get DMs for overbids, transfer offers, and board signals",
    "subtitle": "Add your Discord ID under Profile. You'll stay in the loop even when the app isn't open.",
    "cta": "Add",
    "dismissAria": "Hide"
  },
  "seasonBanner": {
    "title": "Season {number}",
    "status": {
      "active": "Active",
      "upcoming": "Upcoming",
      "completed": "Completed"
    },
    "ended": "Season has ended",
    "daysLeftSuffix": "days until season ends",
    "stages": "{completed}/{total} stages",
    "stagesLive": "{count} live",
    "viewCalendar": "View calendar"
  },
  "cards": {
    "myResult": {
      "title": "How your team did",
      "linkFull": "Full result",
      "newBadge": "New",
      "oneDay": "One-day race",
      "stagesCount": "{count} stages",
      "moreRiders": "+{count, plural, one {# more rider} other {# more riders}}",
      "points": "Points",
      "prize": "Prize money",
      "pointsShort": "{value} pt",
      "thisRace": "This race",
      "earlier": "Earlier races",
      "showAll": "Show all {count}",
      "showLess": "Show less",
      "season": "This season",
      "seasonRaces": "{count, plural, one {# race} other {# races}}",
      "stageWins": "{count, plural, one {# stage win} other {# stage wins}}",
      "empty": "Your riders haven't raced yet. Your team's results land here after the first race.",
      "emptyCta": "Open the race calendar",
      "firstRaceTitle": "Your first race is in the books",
      "firstRaceIntro": "Run while you were away. Here is how it went.",
      "firstRaceIntroAt": "Finished {time} while you were away. Here is how it went.",
      "firstRaceCta": "Read the full race story",
      "firstRaceNext": "Next race: {race}, {count, plural, one {in # day} other {in # days}}",
      "confettiTitleGc": "GC won!",
      "confettiTitleRace": "Race won!",
      "breakdown": {
        "show": "See breakdown",
        "hide": "Hide breakdown",
        "stage": "Stage {number} placing",
        "teamBonus": "Team bonus",
        "sponsor": "Sponsor payout",
        "sponsorRaceDay": "Race-day income",
        "sponsorResultBonus": "Result bonus"
      }
    },
    "maidenWin": {
      "title": "Career moments",
      "unknownRider": "Your rider",
      "viewRace": "View race",
      "headline": {
        "maidenWin": "Rider's first win",
        "firstPodium": "First podium",
        "firstJersey": "First jersey",
        "clubMilestoneWin": "Club milestone"
      },
      "body": {
        "maidenWin": "wins their first professional race in club colours: {race}",
        "firstPodium": "reaches their first career podium: {race}",
        "firstJersey": "wins their first classification jersey: {race}",
        "clubMilestoneWin": "brings up win number {count} for {team}"
      }
    },
    "heroAgony": {
      "title": "Hero & Agony",
      "linkFull": "Open race",
      "eyebrow": {
        "hero": "Hero",
        "agony": "Agony",
        "moment": "Moment"
      },
      "meta": "{race}, stage {stage}",
      "metaOneDay": "{race}",
      "exportCta": "Share as image",
      "exportedFilenamePrefix": "cycling-zone-hero-agony",
      "empty": "No stage moment yet. Your first race day will show up here.",
      "moments": {
        "sprint_win": "{rider} won the sprint finish.",
        "close_win": "{rider} won by just {seconds, plural, one {# second} other {# seconds}}.",
        "close_win_generic": "{rider} held on for the win in the closest of finishes.",
        "solo_win": "{rider} rode clear and won alone off the front.",
        "itt_win": "{rider} set the fastest time of the day.",
        "ttt_win": "{rider} led home the fastest team of the day.",
        "breakaway_survived": "{rider} made the breakaway stick and won from out front.",
        "gc_takeover_won": "{rider} took over the race lead from {previousLeader}.",
        "gc_takeover_lost": "{rider} lost the race lead to {newLeader}.",
        "final_gc": "{rider} finished #{rank} overall.",
        "favorite_off_day": "{rider} entered the stage as the pre-race favourite but finished #{rank}: {reason, select, jour_sans {an off day} incident {a crash or mechanical} helper_work {a shift spent working for a teammate} other {no clear reason}}.",
        "helper_shift": "{count, plural, one {One teammate gave} other {# teammates gave}} up their own chances to bring {captain} to the front.",
        "tag_helper_sacrifice": "{rider} gave up his own result, finishing #{rank}, to work for {captain}.",
        "form_peak": "{rider} arrived in top form and delivered.",
        "tag_perfect_peak": "{rider} won on the exact stage he peaked for.",
        "tag_peak_day": "{rider} timed his form to peak for this stage.",
        "tag_jour_sans": "{rider} just didn't have the legs today.",
        "tag_crash_ruined": "{rider}'s stage was wrecked by a {kind, select, crash {crash} mechanical {mechanical problem} other {incident}}.",
        "incident_abandon": "{kind, select, crash {{rider} abandoned the stage after a crash.} mechanical {{rider} abandoned the stage after a mechanical problem.} injury {{rider} did not start the stage: injured.} other {{rider} abandoned the stage after an incident.}}",
        "incident_time_loss": "{rider} lost {seconds, plural, one {# second} other {# seconds}} to a {kind, select, crash {crash} mechanical {mechanical problem} other {incident}}.",
        "incident_time_loss_generic": "{rider} lost time to a {kind, select, crash {crash} mechanical {mechanical problem} other {incident}}.",
        "tag_outsider_win": "{rider} won without being the strongest rider on paper.",
        "tag_aggression_no_cost": "{rider} attacked and got caught, but it cost nothing: a breakaway attempt never costs extra fatigue or your own finish.",
        "tag_saved_effort": "{rider} eased off today, saving something for what's ahead.",
        "tag_gave_everything": "{rider} held nothing back, full effort all the way.",
        "team_day": "{team} put {count} riders in the top 10 today.",
        "breakaway_effort": "{rider} spent the stage in the breakaway, caught just before the line.",
        "plain_result": "{rider} crossed the line in #{rank}."
      }
    },
    "auctions": {
      "title": "Active auctions",
      "linkAll": "See all",
      "empty": "No active auctions",
      "emptyCta": "Browse the auction market",
      "emptyHint": "Auctions run every day from 08:00 to 24:00.",
      "expired": "Expired",
      "winning": "Winning",
      "selling": "Selling",
      "timeLeftHm": "{h}h {m}m",
      "timeLeftM": "{m}m"
    },
    "transfers": {
      "title": "Transfers and offers",
      "linkAll": "See all",
      "empty": "No pending transfers",
      "emptyCta": "Browse riders for sale",
      "emptyHint": "The transfer market is open all season.",
      "incomingCount": "{count, plural, one {1 incoming transfer} other {# incoming transfers}}",
      "from": "From: {name}",
      "to": "To: {name}",
      "needsAction": "Needs action",
      "active": "Active"
    },
    "races": {
      "title": "Upcoming races",
      "linkAll": "Calendar",
      "empty": "No scheduled races",
      "emptyCta": "Open the race calendar",
      "emptyHint": "Your division's next races show up here.",
      "stages": "{count, plural, one {1 stage} other {# stages}}",
      "oneDay": "One-day race",
      "scheduled": "Scheduled",
      "live": "Live"
    },
    "standings": {
      "title": "Division {division} · Standings",
      "titlePool": "{label} · Standings",
      "linkAll": "Full standings",
      "empty": "No season data yet",
      "emptyCta": "View full standings",
      "emptyHint": "Standings update after each completed race day.",
      "aiBadge": "AI",
      "managerRank": "#{rank} among managers"
    },
    "board": {
      "title": "Board status",
      "linkAll": "Details",
      "satisfaction": "Satisfaction",
      "focus": "Focus",
      "budgetMultiplier": "Budget multiplier",
      "exceeds": "Exceeded",
      "exceedsTitle": "This category scored above 100%. You exceeded the board's expectations here.",
      "meetingNudge": {
        "title": "The annual meeting is open",
        "subtitle": "Your board has proposed next season's mandate. Adjust, request, and sign.",
        "daysLeft": "{count, plural, one {# day left before auto-sign} other {# days left before auto-sign}}",
        "cta": "Go to the annual meeting"
      }
    },
    "recentResults": {
      "title": "Recent results",
      "linkAll": "See all",
      "empty": "Results appear here after the first races",
      "emptyCta": "Open the race calendar",
      "gc": "Overall winner",
      "winner": "Winner",
      "stage": "Stage {n} winner",
      "aiBadge": "AI"
    },
    "riderRanking": {
      "title": "Rider ranking",
      "scopeLabel": "Your division",
      "linkAll": "Full ranking",
      "empty": "Results appear here after the first races",
      "emptyCta": "Open the race calendar",
      "stageWins": "{count, plural, one {1 stage win} other {# stage wins}}",
      "gcWins": "{count} GC",
      "classicWins": "{count} classic",
      "points": "{points} pts",
      "aiBadge": "AI"
    }
  },
  "customize": {
    "button": "Customize",
    "heading": "Show modules",
    "reset": "Reset to default",
    "modules": {
      "nextActions": "Next move",
      "forecast": "Finance forecast",
      "myLatestResult": "How your team did",
      "heroAgony": "Hero & Agony",
      "auctions": "Active auctions",
      "transfers": "Transfers and offers",
      "races": "Upcoming races",
      "divStandings": "Division standings",
      "board": "Board status",
      "recentResults": "Recent results",
      "riderRanking": "Rider ranking",
      "globalRank": "Global Rank",
      "forumHighlights": "From the forum"
    }
  },
  "forumHighlights": {
    "title": "From the forum",
    "allThreads": "All threads",
    "emptyTitle": "Nothing new since your last visit.",
    "emptyDescription": "Check back later or start a new thread."
  },
  "board": {
    "focus": {
      "balanced": "Balanced",
      "youth_development": "Youth development",
      "star_signing": "Star signing"
    }
  },
  "forecast": {
    "loading": "Calculating forecast…",
    "title": "Next season · forecast",
    "subtitle": "Expected cashflow based on roster + loans + sponsor + operating costs",
    "tier": {
      "green": {
        "label": "Green",
        "headline": "Healthy finances",
        "summary": "Expected surplus and debt under control. You can play offensive."
      },
      "yellow": {
        "label": "Yellow",
        "headline": "Thin margin",
        "summary": "Not much room. One bad race or an expensive contract can flip it."
      },
      "red": {
        "label": "Red",
        "headline": "Bankruptcy risk",
        "summary": "Heavy deficit or debt near the cap. Act now."
      }
    },
    "projectedLabel": "Expected net next season",
    "rangeLine": "Range: {low} to {high} (based on the prize estimate's uncertainty)",
    "columns": {
      "s2": "This season (S{number})",
      "s3": "Next season (S{number})",
      "toggleAria": "Choose which season's column to show"
    },
    "chip": {
      "signedContracts": "Signed contracts"
    },
    "row": {
      "sponsorBase": "Sponsor (base)",
      "sponsorVariable": "Sponsor (variable)",
      "sponsorInSeasonBonus": "Sponsor (in-season bonuses)",
      "prize": "Prize money",
      "salary": "Salary",
      "upkeep": "Division upkeep",
      "travelStaff": "Travel & staff",
      "staffFacilities": "Staff and facilities",
      "facilityUpkeep": "Facility upkeep",
      "staffSalary": "Staff salaries",
      "loanInterest": "Loan interest",
      "academyDrift": "Academy upkeep"
    },
    "sponsorDetail": {
      "contract": "Next season's sponsor: {sponsor} · guaranteed base {base}, race-day income on top",
      "variable": "Base {base} + variable {variable} from last season's rank/points",
      "intro": "Intro season: variable sponsor starts from season 2",
      "fallback": "Fallback: missing standings for the previous season",
      "s2Combined": "This season shows the full amount credited in one payment, base and performance bonus combined. Next season splits the two below.",
      "inSeasonBonus": "Race-day, result, objective, and signing bonuses actually earned this season. Not forecasted for next season, since it depends on results not yet run."
    },
    "prizeDetail": {
      "realizedFloor": "My estimate is based on your team's earned prizes, plus/minus 20%; not a measured range",
      "divisionInterval": "My estimate for your team, plus/minus 20%; not a measured range"
    },
    "upkeepDetail": {
      "perRaceDay": "{rate} per senior race day × {days} race days. Charged when each race is settled, not at season start.",
      "byDivision": "Set by your division, not your squad"
    },
    "salaryDetail": {
      "productionS3": "Wages from your contracts. A rider whose contract runs out is shown at his extension wage.",
      "seasonSwitch": "Season {next} wages are the wages in your contracts. A rider whose contract runs out is shown at the wage he gets if you extend him."
    },
    "loanInterestDetail": "Interest accrued on your active loans' outstanding debt. Added to the loan itself, not deducted from net.",
    "assumption": "Assumes your current squad, no transfers, and the season {next} wage system.",
    "footnote": "Forecast, not a contract. Numbers may change due to sales, loans, or a new board plan.",
    "footnoteLink": "How is the forecast calculated?",
    "badge": {
      "label": "Forecast next season"
    },
    "horizon": {
      "label": "Forecast horizon:",
      "option": "{count, plural, one {1 season} other {# seasons}}",
      "rangeSuffix": "({from}–{to})"
    },
    "multiSeason": {
      "title": "Season by season (estimate from season {from} ->)",
      "headers": {
        "season": "Season",
        "sponsor": "Sponsor",
        "prize": "Prize",
        "salary": "Salary",
        "interest": "Interest",
        "net": "Net",
        "endBalance": "End balance",
        "risk": "Risk"
      },
      "estimateMark": "~",
      "estimateTooltip": "Estimate, assumes status quo",
      "total": "Total",
      "estimateNote": "~ = estimate based on a status-quo assumption (same roster, sponsor, and 25% loan-decay per season). Interest is added to your outstanding debt, not deducted from net."
    }
  },
  "onboardingProgress": {
    "header": "Get started · {completed}/{total} steps complete",
    "steps": {
      "first_bid_placed": "Place your first bid",
      "first_training_run": "Run your first training day",
      "first_squad_selected": "Select your squad for a race",
      "board_plan_set": "Negotiate a board plan",
      "board_plan_set_auto": "Your board has set a plan. Take a look."
    },
    "ctas": {
      "first_bid_placed": "See auctions",
      "first_training_run": "Go to training",
      "first_squad_selected": "Go to races",
      "board_plan_set": "Meet the board"
    },
    "oneClick": {
      "primaryCta": "Run this week's training",
      "secondaryCta": "Pick it myself",
      "resultLine": "Week run: {count, plural, one {# rider trained} other {# riders trained}}.",
      "resultLink": "See training",
      "alreadyRun": "This week is already run.",
      "error": "Could not run this week's training. Try again."
    },
    "tour": "Show me how",
    "dismissAria": "Hide"
  },
  "onboardingComplete": {
    "title": "You're ready. The basics are done",
    "body": "All four getting-started steps are checked off. Next phase is building your team across multiple seasons. Deliver on the board's targets and fight for promotion.",
    "nextLinks": {
      "board": {
        "label": "Board",
        "desc": "Negotiate 1yr/3yr/5yr plans in parallel"
      },
      "help": {
        "label": "Help and rules",
        "desc": "Learn how the economy, racing, and tactics work"
      }
    },
    "dismissAria": "Hide"
  },
  "devTransition": {
    "title": "The development view has changed",
    "intro": "Your riders have not changed. Abilities, ratings and results are exactly as yesterday. What is new is what the number shows: before, the profile showed a theoretical ceiling. Now it shows both the ceiling and where each rider realistically lands with your training.",
    "factAbilitiesTitle": "Abilities and results",
    "factAbilitiesSub": "unchanged for every rider",
    "factCeilingsTitle": "Ceilings raised",
    "factCeilingsSub": "for {up} of your {total} riders",
    "factForecastTitle": "New: projected level",
    "factForecastSub": "the forecast your training steers",
    "colRider": "Rider",
    "colRating": "Rating",
    "colCeilBefore": "Ceiling before",
    "colCeilNow": "Ceiling now",
    "colForecast": "Projected level (new)",
    "loweredNote": "Some riders sit above their new ceiling on a few abilities. They keep everything and simply hold there. No rider loses a single point.",
    "helpLink": "How development works",
    "dismiss": "Got it"
  },
  "surveyInvite": {
    "title": "Help me decide what to build next",
    "subtitle": "Rate each idea twice. It takes about 5 minutes.",
    "cta": "Answer now",
    "dismissAria": "Hide the survey card"
  }
}
